module.exports = __webpack_public_path__ + "img/2020SecurityAwarenessTraining.ad520a55.jpg";